module.exports = __webpack_public_path__ + "img/logo.6b2c6f2c.svg";